const fastTrackPresentingComplaints = [
  'Advice only (no treatment required)',
  'Animal or Insect Bite / Sting',
  'Blister',
  'Bruise or contusion',
  'Dressing change only',
  'Eye irritation (e.g. dust, sunscreen)',
  'Foreign body (skin or eye)',
  'General minor pain',
  'Graze',
  'Heat exhaustion (mild)',
  'Loose or avulsed tooth',
  'Minor burn or scald',
  'Minor cut or laceration',
  'Minor head injury',
  'Minor intoxication (no risk to self/others)',
  'Minor nosebleed',
  'Minor soft tissue injury',
  'Other',
  'Post-fall check (no injury found)',
  'Skin rash (non-urgent)',
  'Splinter',
  'Stubbed toe or finger',
  'Sunburn (mild)',
  'Vomiting (isolated episode)',
  'Welfare only',
]

export default fastTrackPresentingComplaints
